
import { Route, Switch } from "react-router-dom";
import "./App.css";
import LandingPage from "./components/LandingPage";
import VideoPage from "./components/VideoPage";

function App() {

  return (
    <div className="App">
      <Switch>
        <Route exact path="/" component={LandingPage} />
        <Route  path="/video/:id" component={VideoPage} />
        {/* <LandingPage /> */}
        
        </Switch>
    </div>
  );
}

export default App;
